import { useMemo } from 'react'

import ScrollToTop from 'shared/utils/router/ScrollToTop'
import { Areas, Component } from 'site/shared/types'
import {
  Automation,
  useAutomation,
  useSitemodelContentAggregator
} from 'sitemodel/shared/hooks'
import { SitemodelContextValue } from 'sitemodel/shared/types'
import { SitemodelManifestStateGrouped } from 'sitemodel/shared/types/sitemodel.type'
import LoadComponent from './LoadComponent'

export type RendererProps = SitemodelContextValue & {
  areas?: Areas[]
  components?: Component[]
  globalComponents?: Component[]
  state?: SitemodelManifestStateGrouped['filteraction']
  automations?: Automation[]
}

const Renderer = (props: RendererProps) => {
  const { areas, components, globalComponents } = props

  const componentsToRender = useMemo(
    () => [...(areas || components || []), ...(globalComponents || [])],
    [areas, components, globalComponents]
  )

  const state = useMemo(() => props.state || {}, [props.state])

  const automations = useMemo(
    () => props.automations || [],
    [props.automations]
  )

  const { isAutomationRunning } = useAutomation(automations)

  useSitemodelContentAggregator(state)

  if (!componentsToRender || !state || isAutomationRunning) return null

  return (
    <>
      <ScrollToTop />
      <LoadComponent components={componentsToRender} />
    </>
  )
}

export default Renderer
